import { render, staticRenderFns } from "./PendingPartnerBookings.vue?vue&type=template&id=83d7fd00&scoped=true"
import script from "./PendingPartnerBookings.vue?vue&type=script&lang=js"
export * from "./PendingPartnerBookings.vue?vue&type=script&lang=js"
import style0 from "./PendingPartnerBookings.vue?vue&type=style&index=0&id=83d7fd00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d7fd00",
  null
  
)

export default component.exports